import { useNotification } from 'hooks'
import { RecoverPasswordVerify } from 'modules/users/components'
import type { FC } from 'react'
import { UserService } from 'modules/users/services'
import type { RecoverPasswordValidationProps } from '.'

const RecoverPasswordValidation: FC<RecoverPasswordValidationProps> = ({ userEmail, hasValidated, onCancel }) => {
  const { notify } = useNotification()

  async function onSubmit({ code }: { code: string }) {
    try {
      const userService = new UserService()
      await userService.recoverPasswordCheckToken(userEmail, code)

      if (typeof hasValidated === 'function') {
        hasValidated()
      }
    } catch (e) {
      notify({
        title: 'Atenção',
        description: 'O código informado está incorreto!',
        type: 'danger',
      })
    }
  }

  return <RecoverPasswordVerify onSubmit={onSubmit} onCancel={onCancel} />
}

export default RecoverPasswordValidation
